(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4117],{

/***/ 52417:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-bug-right.5afcc5fc.gif","height":400,"width":400});

/***/ }),

/***/ 29204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46466);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const PrimaryButton = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        ...props,
        onClick: (e)=>{
            var ref;
            if (window.dataLayer && ((ref = props.href) === null || ref === void 0 ? void 0 : ref.includes("app.highlight.io/sign_up"))) {
                e.preventDefault();
                if (props.onClick) {
                    props.onClick(e);
                }
                window.gtag("event", "conversion", {
                    send_to: "AW-10833687189/_C5MCLfmoY0YEJXl860o",
                    event_callback: function() {
                        if (props.href) {
                            window.location = props.href;
                        }
                    }
                });
                return false;
            } else {
                if (props.onClick) {
                    props.onClick(e);
                }
            }
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default().genericButton), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_3___default().primaryButton)),
        children: children
    });
};


/***/ }),

/***/ 24035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FooterCallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./public/images/hero-bug-right.gif
var hero_bug_right = __webpack_require__(52417);
;// CONCATENATED MODULE: ./public/images/safety-security-section.gif
/* harmony default export */ var safety_security_section = ({"src":"/_next/static/media/safety-security-section.b1e9c13f.gif","height":700,"width":700});
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
;// CONCATENATED MODULE: ./components/common/CallToAction/FooterCallToAction.tsx









const FooterCallToAction = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Home_module_default()).callToActionBackground,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Home_module_default()).anchorTitle, (Home_module_default()).ctaContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Home_module_default()).footerImageRight,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: hero_bug_right/* default */.Z,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Products_module_default()).subtleBadge,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy4",
                        emphasis: true,
                        children: "Try Highlight Today"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: (Home_module_default()).ctaTitle,
                    children: [
                        "Get the ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Home_module_default()).highlightedText,
                            children: "visibility"
                        }),
                        " you need"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Home_module_default()).buttonContainer, (Home_module_default()).tryButtonContainer),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        href: "https://app.highlight.io/sign_up",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "copy2",
                            emphasis: true,
                            children: "Get started for free"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Home_module_default()).footerImageLeft,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: safety_security_section,
                        alt: ""
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 5945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./components/Products/products.ts
//all products and snippets are defined below for the product page
//referenced in ProductDropdown and sitemap
//whitespace ensures that the two code blocks (front-end and back-end) are the same height.
const defaultFrontendSnippet = "\n\nimport React from 'react'\nimport { H } from 'highlight.run'\nimport { ErrorBoundary } from '@highlight-run/react'\n\nH.init('<YOUR_PROJECT_ID>') // Get your project ID from https://app.highlight.io/setup\n\nReactDOM.render(\n	<React.StrictMode>\n		<ErrorBoundary>\n			<App />\n		</ErrorBoundary>\n	</React.StrictMode>,\n	document.getElementById('root'),\n)\n";
const expressSnippet = "\n\nimport { Handlers } from '@highlight-run/node'\n\nconst app = express()\n\n// define any configurations needed\n// <https://docs.highlight.run/api/hinit#w0-highlightoptions>\nconst highlightOptions = {projectID: 'YOUR_PROJECT_ID'}\nconst highlightHandler = Handlers.errorHandler(highlightOptions)\napp.use(highlightHandler)\n\napp.use('/error', () => {\n  throw new Error('a fake failure was thrown')\n})\n\n";
const goSnippet = '\n\nimport (\n  "github.com/highlight/highlight/sdk/highlight-go"\n)\n\nfunc main() {\n  //...application logic...\n  highlight.Start()\n  defer highlight.Stop()\n  //...application logic...\n}\n\n\n\n\n';
const nodeSnippet = "\n\nimport { H } from '@highlight-run/node'\n\nconst highlightOptions = {}\nif (!H.isInitialized()) {\n  H.init(highlightOptions)\n}\n\nconst onError = (request, error) => {\n	const parsed = H.parseHeaders(request.headers)\n	if (parsed !== undefined) {\n		H.consumeError(error, parsed.secureSessionId, parsed.requestId)\n	}\n}\n\n";
const nextBackendSnippet = "\n\nimport { withHighlight } from '../highlight.config'\n\nconst handler = async (req, res) => {\n  res.status(200).json({ name: 'Jay' })\n}\n\nexport default withHighlight(handler)\n\n\n\n\n\n\n\n";
const angularSnippet = "\n\n//main.ts\nimport { H } from 'highlight.run';\n\nH.init(\n    \"<YOUR_PROJECT_ID>\", // Get your project ID from https://app.highlight.io/setup\n    networkRecording: {\n        enabled: true,\n        recordHeadersAndBody: true,\n    },\n    tracingOrigins: true // Optional configuration of Highlight features\n);\n";
const gatsbySnippet = "\n\nmodule.exports = {\n	plugins: [\n		{\n			resolve: '@highlight-run/gatsby-plugin-highlight',\n			options: {\n				orgID: '<YOUR_PROJECT_ID>', // Get your project ID from https://app.highlight.io/setup\n			},\n		},\n	],\n}\n";
const nextSnippet = "\n\nimport type { AppProps } from 'next/app'\nimport { H } from 'highlight.run'\nimport { ErrorBoundary } from '@highlight-run/react'\n\nH.init('<YOUR_PROJECT_ID>') // Get your project ID from https://app.highlight.io/setup\n\nfunction MyApp({ Component, pageProps }: AppProps) {\n	return (\n		<ErrorBoundary>\n			<Component {...pageProps} />\n		</ErrorBoundary>\n	)\n}\nexport default MyApp\n";
const reactSnippet = "\n\nimport React from 'react'\nimport { H } from 'highlight.run'\nimport { ErrorBoundary } from '@highlight-run/react'\n\nH.init('<YOUR_PROJECT_ID>') // Get your project ID from https://app.highlight.io/setup\n\nReactDOM.render(\n	<React.StrictMode>\n		<ErrorBoundary>\n			<App />\n		</ErrorBoundary>\n	</React.StrictMode>,\n	document.getElementById('root'),\n)\n";
const vueSnippet = "\n\nimport { H } from 'highlight.run'\nimport { createApp } from 'vue'\nimport App from './App.vue'\n\nH.init('9me23yd2') // Get your project ID from https://app.highlight.io/setup\n\ncreateApp(App).mount('#app')\n";
const svelteSnippet = "\n\n... %svelte.head%\n\n<script src=\"https://cdn.jsdelivr.net/npm/highlight.run@latest\"></script>\n<script>\n	window.H.init('<YOUR_PROJECT_ID>')\n</script>\n\n...\n";
const PRODUCTS = {
    react: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/reactjs",
        slug: "react",
        title: "React",
        snippets: [
            reactSnippet
        ]
    },
    next: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/nextjs",
        slug: "next",
        title: "Next.js",
        types: [
            "Frontend",
            "Backend"
        ],
        snippets: [
            nextSnippet,
            nextBackendSnippet
        ]
    },
    angular: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/angular",
        slug: "angular",
        title: "Angular",
        snippets: [
            angularSnippet
        ]
    },
    gatsby: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/gatsbyjs",
        slug: "gatsby",
        title: "Gatsby.js",
        snippets: [
            angularSnippet
        ]
    },
    svelte: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/sveltekit",
        slug: "svelte",
        title: "Svelte.js",
        snippets: [
            svelteSnippet
        ]
    },
    vue: {
        type: "frontend",
        docsLink: "/docs/getting-started/client-sdk/vuejs",
        slug: "vue",
        title: "Vue.js",
        snippets: [
            vueSnippet
        ]
    },
    express: {
        type: "backend",
        docsLink: "/docs/getting-started/4_backend-sdk/express",
        slug: "express",
        title: "Express",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            expressSnippet,
            defaultFrontendSnippet
        ]
    },
    go: {
        type: "backend",
        docsLink: "/docs/getting-started/4_backend-sdk/go",
        slug: "go",
        title: "Golang",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            goSnippet,
            defaultFrontendSnippet
        ]
    },
    "next-backend": {
        type: "backend",
        docsLink: "/docs/getting-started/client-sdk/nextjs",
        slug: "next-backend",
        title: "Next.js",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            nextBackendSnippet,
            nextSnippet
        ]
    },
    node: {
        type: "backend",
        docsLink: "/docs/getting-started/4_backend-sdk/nodejs",
        slug: "node",
        title: "Node.js",
        types: [
            "Backend",
            "Frontend"
        ],
        snippets: [
            nodeSnippet,
            defaultFrontendSnippet
        ]
    }
};
const frontendProductLinks = Object.values(PRODUCTS).filter((product)=>{
    return product.type == "frontend";
});
const backendProductLinks = Object.values(PRODUCTS).filter((product)=>{
    return product.type == "backend";
});
const fullStackProductLinks = Object.values(PRODUCTS).filter((product)=>{
    return product.type == "fullstack";
});

// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx + 2 modules
var HighlightLogo = __webpack_require__(44688);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./components/common/Footer/Footer.module.scss
var Footer_module = __webpack_require__(53480);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./components/common/Footer/Footer.tsx







const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).footerBottom,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_module_default()).socialDiv,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://twitter.com/highlightio",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                            className: (Footer_module_default()).socialIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.linkedin.com/company/highlightrun",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
                                            className: (Footer_module_default()).socialIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://github.com/highlight/highlight",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {
                                            className: (Footer_module_default()).socialIcon
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Product"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/pricing",
                                                children: "Pricing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://app.highlight.io/sign_up",
                                                children: "Sign up"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/#features",
                                                children: "Features"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/privacy",
                                                children: "Privacy & Security"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/#customers",
                                                children: "Customers"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Developers"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://feedback.highlight.run/changelog",
                                                children: "Changelog"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/docs",
                                                children: "Documentation"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Frameworks"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: Object.entries(PRODUCTS).map((param)=>{
                                        let [key, value] = param;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/for/".concat(value.slug),
                                                children: value.title
                                            })
                                        }, value.docsLink);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Footer_module_default()).footerTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    emphasis: true,
                                    children: "Contact & Legal"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: (Footer_module_default()).footerList,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/terms",
                                                children: "Terms of Service"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/privacy",
                                                children: "Privacy Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://careers.highlight.run/",
                                                children: "Careers"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:sales@highlight.io",
                                                children: "sales@highlight.io"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:security@highlight.io",
                                                children: "security@highlight.io"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).footerBottomMobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HighlightLogo/* HighlightLogo */.R, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).socialDiv,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/highlightio",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                                    className: (Footer_module_default()).socialIcon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.linkedin.com/company/highlightrun",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
                                    className: (Footer_module_default()).socialIcon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://github.com/highlight/highlight",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaGithub */.hJX, {
                                    className: (Footer_module_default()).socialIcon
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ }),

/***/ 44688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ HighlightLogo; },
  "s": function() { return /* binding */ HighlightLogoWhite; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/logo-and-text-on-dark.svg
/* harmony default export */ var logo_and_text_on_dark = ({"src":"/_next/static/media/logo-and-text-on-dark.86efd8f2.svg","height":33,"width":167});
;// CONCATENATED MODULE: ./public/images/logo-and-text-on-purple.svg
/* harmony default export */ var logo_and_text_on_purple = ({"src":"/_next/static/media/logo-and-text-on-purple.0665af5c.svg","height":33,"width":167});
// EXTERNAL MODULE: ./components/common/HighlightLogo/HighlightLogo.module.scss
var HighlightLogo_module = __webpack_require__(44579);
var HighlightLogo_module_default = /*#__PURE__*/__webpack_require__.n(HighlightLogo_module);
;// CONCATENATED MODULE: ./components/common/HighlightLogo/HighlightLogo.tsx





const HighlightLogo = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightLogo_module_default()).logoDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: logo_and_text_on_dark,
            alt: ""
        })
    });
};
const HighlightLogoWhite = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HighlightLogo_module_default()).logoDiv,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: logo_and_text_on_purple,
            alt: ""
        })
    });
};


/***/ }),

/***/ 20026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Typography; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46717);
/* harmony import */ var _Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Typography = (param)=>{
    let { children , emphasis =false , onDark =false , className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, {
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copyHeader)]: props.type === "copyHeader",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy1)]: props.type === "copy1",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy2)]: props.type === "copy2",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy3)]: props.type === "copy3",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().copy4)]: props.type === "copy4",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().outline)]: props.type === "outline",
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().emphasis)]: emphasis,
            [(_Typography_module_scss__WEBPACK_IMPORTED_MODULE_3___default().onDark)]: onDark
        }),
        children: children
    });
};


/***/ }),

/***/ 19350:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgPosition":"Home_bgPosition__wAgzT","purpleDiv":"Home_purpleDiv__U1nYG","blueDiv":"Home_blueDiv__5yHEw","highlightedText":"Home_highlightedText__8FhfX","mobileOnly":"Home_mobileOnly__aBfw6","hideImage":"Home_hideImage__Plyay","hero":"Home_hero___9_fZ","bigHero":"Home_bigHero__mHvsY","heroVideoWrapper":"Home_heroVideoWrapper__EHYd2","heroBug":"Home_heroBug__0zF_Z","footerImageLeft":"Home_footerImageLeft__WsciO","footerImageRight":"Home_footerImageRight__XpAKQ","search":"Home_search__cFkvx","searchTwoHighlighters":"Home_searchTwoHighlighters__ogBBt","obfuscation":"Home_obfuscation__wu3rO","obfuscationImage":"Home_obfuscationImage__piAA3","obfuscationHandle":"Home_obfuscationHandle__lK2O8","arrow1":"Home_arrow1__b8JhO","arrow2":"Home_arrow2__VX9LF","secondaryBackground":"Home_secondaryBackground__Zx2wQ","bodyLarge":"Home_bodyLarge__tSI5E","bodySmall":"Home_bodySmall__EXSbN","gradientText":"Home_gradientText__IArQU","carouselButton":"Home_carouselButton__P59J_","carouselContainer":"Home_carouselContainer__Ch0IB","innerCarouselFeature":"Home_innerCarouselFeature__Eeegy","innerCarouselButton":"Home_innerCarouselButton__5M3Pe","featuresColumnContainer":"Home_featuresColumnContainer__pStUx","featuresSection":"Home_featuresSection__l9CPb","featuresLeftColumn":"Home_featuresLeftColumn__9D9at","featuresRightColumn":"Home_featuresRightColumn__jteoH","sectionText":"Home_sectionText__wDy47","codeSection":"Home_codeSection__VT9qe","sectionSubtitle":"Home_sectionSubtitle__4rtrm","heroImage":"Home_heroImage__WKvpt","sectionCollapse":"Home_sectionCollapse__X6LN3","collapseHeader":"Home_collapseHeader__uElNF","sectionBody":"Home_sectionBody__mCAeO","sectionInfo":"Home_sectionInfo__2iFG2","sectionImageRight":"Home_sectionImageRight__1xodv","sectionImageLeft":"Home_sectionImageLeft__ETiIR","gridSectionImageLeft":"Home_gridSectionImageLeft__23JPF","imageInner":"Home_imageInner__dGWRZ","buttonContainer":"Home_buttonContainer__EQoF4","anchorTitle":"Home_anchorTitle__nlk3B","anchorFeature":"Home_anchorFeature___BCJT","secondaryAnchor":"Home_secondaryAnchor__ZBaJx","anchorHead":"Home_anchorHead__VFK66","landingAnchorHead":"Home_landingAnchorHead__yx61Q","hideVideo":"Home_hideVideo__6MnYf","modalBg":"Home_modalBg__687XX","modalClose":"Home_modalClose__EaHCX","videoModal":"Home_videoModal__H3dO2","anchorImage":"Home_anchorImage__VpZv6","thumbnail":"Home_thumbnail__4ICK8","playButton":"Home_playButton__S6Kth","playButtonIcon":"Home_playButtonIcon__3XStT","jayImage":"Home_jayImage__wCQ8Q","playCard":"Home_playCard__Pz3Ti","reviewCard":"Home_reviewCard__UrEJs","reviewText":"Home_reviewText__D98qS","author":"Home_author__lDCTd","authorImage":"Home_authorImage__TCSy0","companyLogo":"Home_companyLogo__zDXHQ","slider":"Home_slider__U9_UX","slideTrack":"Home_slideTrack__YI_Es","featureContainer":"Home_featureContainer__w9_U6","featureItem":"Home_featureItem__P5rMf","snippetTabs":"Home_snippetTabs__gGjHj","snippetTab":"Home_snippetTab__VDY3N","tabSelected":"Home_tabSelected__XI_us","snippetBeta":"Home_snippetBeta__HLkL5","codeSnippetFrame":"Home_codeSnippetFrame__cbeSD","codeSnippetTopbar":"Home_codeSnippetTopbar__hMBYe","codeSnippetButtons":"Home_codeSnippetButtons___6sSK","codeSnippetIcon":"Home_codeSnippetIcon__TWl9b","codeSnippetCircle":"Home_codeSnippetCircle__4DcAU","codeSnippetContent":"Home_codeSnippetContent__ijs7O","codeSnippetCopy":"Home_codeSnippetCopy__D2JjV","codeSnippetCopyIcon":"Home_codeSnippetCopyIcon__5c2fr","snippetContent":"Home_snippetContent__8vJ0S","simpleCallToActionBackground":"Home_simpleCallToActionBackground__3_HIR","ctaContainer":"Home_ctaContainer__b0AdQ","callToActionBackground":"Home_callToActionBackground__6oa7a","ctaTitle":"Home_ctaTitle__b9XOq","ctaBg":"Home_ctaBg__rJNt3","anchorSmall":"Home_anchorSmall__9aaME","tryButtonContainer":"Home_tryButtonContainer__Hg9Z2","ossCard":"Home_ossCard__TvoFX","hollowButton":"Home_hollowButton__xgjkW","solidButton":"Home_solidButton__KDQjm","whiteButton":"Home_whiteButton__wj4ES","customerReel":"Home_customerReel__IyG_E","infoContainer":"Home_infoContainer__ZN8Ov","landingInfoRow":"Home_landingInfoRow__x3lbc","companies":"Home_companies__hnoH0","scaleHeight":"Home_scaleHeight__sk2mZ","customerCopy":"Home_customerCopy__TFmmF","buttonArrow":"Home_buttonArrow__X5__0","arrow":"Home_arrow__wJ3BP","hideMobile":"Home_hideMobile__km2kc","hidePhone":"Home_hidePhone__P85fL","mobile":"Home_mobile__7C5FA","tabletGraphic":"Home_tabletGraphic__fpYA0","snippetDropdownContainer":"Home_snippetDropdownContainer__og6TK","snippetDropdown":"Home_snippetDropdown__Drnq0","snippetDropdownValue":"Home_snippetDropdownValue__zs1LC","snippetDropdownList":"Home_snippetDropdownList__xZURP","collaborationGraphic":"Home_collaborationGraphic__Fju9A","heroBugLeft":"Home_heroBugLeft__SONAZ","heroBugRight":"Home_heroBugRight__dcnHU","mobileSpacing":"Home_mobileSpacing__fhaMr","scroll":"Home_scroll__csog8"};

/***/ }),

/***/ 49879:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"highlightedBadge":"Products_highlightedBadge__6Uft5","subtleBadge":"Products_subtleBadge__Aj8X1","anchorFeature":"Products_anchorFeature__cQ3jd","buttonContainer":"Products_buttonContainer__eY3Z5","featureBox":"Products_featureBox__AJuwp","featureBoxIcon":"Products_featureBoxIcon__GvWMG","featureBoxText":"Products_featureBoxText__e06jy","snippet":"Products_snippet__KcE0k","divider":"Products_divider__GcLqX","hollowButton":"Products_hollowButton__mFcnB","docsButton":"Products_docsButton__s5paO","infoContainer":"Products_infoContainer__wQjcX","infoTitle":"Products_infoTitle__LO64z"};

/***/ }),

/***/ 46466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"Buttons_genericButton__1FVcd","primaryButton":"Buttons_primaryButton__F0qwS","secondaryButton":"Buttons_secondaryButton__ONMAh","arrow":"Buttons_arrow__FYbFj"};

/***/ }),

/***/ 53480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__8ba8J","footerTitle":"Footer_footerTitle__YyFKw","footerList":"Footer_footerList__VqicJ","footerBottom":"Footer_footerBottom__u2Y1_","footerBottomMobile":"Footer_footerBottomMobile__MN_9g","copyrightText":"Footer_copyrightText__YVr9H","socialDiv":"Footer_socialDiv__mojo7","socialIcon":"Footer_socialIcon__OIz7r","status":"Footer_status__fVYZR","statusDiv":"Footer_statusDiv__ipM1k","statusCircle":"Footer_statusCircle__XNZ7q"};

/***/ }),

/***/ 44579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logoDiv":"HighlightLogo_logoDiv__7LoQB","logoText":"HighlightLogo_logoText__yxbvU","logo":"HighlightLogo_logo__bx_mM"};

/***/ }),

/***/ 36109:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__Hki0p","hide":"Navbar_hide__zNudc","header":"Navbar_header__4yLzB","headerPadding":"Navbar_headerPadding__I31dq","headerInner":"Navbar_headerInner__WU6T_","headerBorder":"Navbar_headerBorder__vq_i7","hideNavbar":"Navbar_hideNavbar__aZu63","navContainer":"Navbar_navContainer__Pkz7d","navMenu":"Navbar_navMenu__vSmJQ","mobileMenu":"Navbar_mobileMenu__lUigM","menuList":"Navbar_menuList__bWJqX","menuItem":"Navbar_menuItem__q_j2E","chevronDown":"Navbar_chevronDown__L4333","menuDropdown":"Navbar_menuDropdown__oDsSP","headerButton":"Navbar_headerButton__zJw2r","headerButtonRight":"Navbar_headerButtonRight__s4Uep","popoverButton":"Navbar_popoverButton__WiIZs","popover":"Navbar_popover__VpYiX","popoverPanel":"Navbar_popoverPanel___S3Zu","innerPopoverPanel":"Navbar_innerPopoverPanel__IVRN3","copyOnLight":"Navbar_copyOnLight__hCG9U","copyOnDark":"Navbar_copyOnDark__o_J8Z","white":"Navbar_white__e_2Nx","gridContainer":"Navbar_gridContainer__G_6Aq","innerGridContainer":"Navbar_innerGridContainer__3rIoQ","gridItem":"Navbar_gridItem__OAdnU","signUpButton":"Navbar_signUpButton__p_R_j","headerLeft":"Navbar_headerLeft__pZY9_","headerLeftBlog":"Navbar_headerLeftBlog__mTNOx","headerCenter":"Navbar_headerCenter__flPxm","headerRight":"Navbar_headerRight__IvOsm","socialButtonContainer":"Navbar_socialButtonContainer__5c9GH","socialButtonWrapper":"Navbar_socialButtonWrapper__xU9QK","socialButton":"Navbar_socialButton__UeEDd","socialButtonWrapperLeft":"Navbar_socialButtonWrapperLeft__mYCJz","socialButtonWrapperRight":"Navbar_socialButtonWrapperRight__TlP3q","socialButtonDivider":"Navbar_socialButtonDivider__bzsqw","urlStyle":"Navbar_urlStyle__VOVlz","dropdownItem":"Navbar_dropdownItem__Y_43b","bannerContainer":"Navbar_bannerContainer__NWyOW","callToAction":"Navbar_callToAction__v1q4L","bannerContainerBlog":"Navbar_bannerContainerBlog__a6fvz","navTitle":"Navbar_navTitle__pjZ9_","navPostTitle":"Navbar_navPostTitle__O2TUd","loadingBar":"Navbar_loadingBar__BZ3Iq","fixed":"Navbar_fixed__NYJVb","openHeader":"Navbar_openHeader__pxQwC","mobileHeader":"Navbar_mobileHeader__rk96w","menuButtons":"Navbar_menuButtons__8kzLj","menuItemLarge":"Navbar_menuItemLarge__B4JsK"};

/***/ }),

/***/ 46717:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"copyHeader":"Typography_copyHeader__vgPrK","copy1":"Typography_copy1__Cenb_","copy2":"Typography_copy2__ebmOc","copy3":"Typography_copy3__66v_e","copy4":"Typography_copy4__R2A2_","onDark":"Typography_onDark__0klmC","emphasis":"Typography_emphasis__GjrIs","outline":"Typography_outline__J0c64"};

/***/ })

}]);